module.exports = __webpack_public_path__ + "img/Frequency35MHz-gray.3489d9fd.svg";